import script from "./MenuTree.vue?vue&type=script&lang=ts&setup=true"
export * from "./MenuTree.vue?vue&type=script&lang=ts&setup=true"

import "./MenuTree.vue?vue&type=style&index=0&id=3834b14f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3834b14f"]])

export default __exports__